<template>
  <div class="attachments-wrapper">
    <pre-loader :value="load" />
    <button v-if="!attachedFiles.length" class="btn btn-onlytext">
      No file(s)
    </button>
    <transition name="fade" tag="div">
      <div class="dropdown-file-holder">
        <pre-loader :value="loadFile" />
        <button
          v-if="attachedFiles.length"
          @click="dropDownFile = !dropDownFile"
          class="btn btn-white dropdown-file">
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.85294 10.1562C8.68247 10.1562 8.52806 10.2245 8.41647 10.3346L7.82353 10.9196V7.1045C8.07224 6.91925 8.23529 6.62756 8.23529 6.29688C8.23529 5.73584 7.77453 5.28125 7.20588 5.28125C6.63724 5.28125 6.17647 5.73584 6.17647 6.29688C6.17647 6.62797 6.33953 6.91925 6.58824 7.1045V10.9196L5.99529 10.3346C5.88371 10.2245 5.72929 10.1562 5.55882 10.1562C5.21788 10.1562 4.94118 10.4292 4.94118 10.7656C4.94118 10.9338 5.01035 11.0862 5.12235 11.1962L6.76941 12.8212C6.881 12.9318 7.03541 13 7.20588 13C7.37635 13 7.53076 12.9318 7.64276 12.8217L9.28982 11.1967C9.40141 11.0862 9.47059 10.9338 9.47059 10.7656C9.47059 10.4292 9.19388 10.1562 8.85294 10.1562ZM12.3529 4.67188C12.3529 3.0225 11.0242 1.68309 9.366 1.63028C8.57418 0.638625 7.34959 0 5.97059 0C3.67253 0 1.79859 1.77003 1.66024 4.00319C0.674059 4.51181 0 5.52866 0 6.70312C0 8.38622 1.38229 9.75 3.08824 9.75H3.91176C4.25271 9.75 4.52941 9.477 4.52941 9.14062C4.52941 8.80425 4.25271 8.53125 3.91176 8.53125H3.08824C2.06665 8.53125 1.23529 7.71103 1.23529 6.70312C1.23529 6.02103 1.61741 5.40028 2.23259 5.08341L2.85065 4.7645L2.89347 4.07753C2.99271 2.47447 4.34453 1.21875 5.97059 1.21875C6.92053 1.21875 7.80418 1.64369 8.39588 2.38428L8.75167 2.82994L9.32649 2.84822C10.3308 2.88031 11.1176 3.68144 11.1176 4.67188V5.48397L11.8778 5.79678C12.4163 6.01859 12.7647 6.53372 12.7647 7.10938C12.7647 7.89344 12.1182 8.53125 11.3235 8.53125H10.5C10.1591 8.53125 9.88235 8.80425 9.88235 9.14062C9.88235 9.477 10.1591 9.75 10.5 9.75H11.3235C12.8018 9.75 14 8.56781 14 7.10938C14 6.01087 13.3202 5.07 12.3529 4.67188Z"
              fill="#1D89BF"
            />
          </svg>

          <span v-if="attachedFiles.length > 1">  {{ attachedFiles.length }} files</span>

          <span
            v-if="attachedFiles.length === 1"
            @click="
              downloadAttachedFiles(
                attachedFiles[0].DownloadLink,
                attachedFiles[0].AttachName
              )
            ">
            {{ attachedFiles[0].AttachName.substring(30, -1) }}
            <span v-if="attachedFiles[0].AttachName.length > 30" class="dots">…</span>
          </span>
        </button>

        <button
          v-if="
            controlView == 'PMInterface' &&
              attachedFiles.length == 1 &&
              jobData.JobTypeData.JobStatusName !== 'Ready' &&
              jobData.JobTypeData.JobStatusName !== 'Cancelled'
          "
          @click="deleteAttachedFile(attachedFiles[0].AttachGUID)"
          class="btn dropdown-file-remove">
          <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="right svg-ic-del"
            style="cursor: pointer">
            <path
              d="M1.13551 15.1224C1.13551 15.331 1.29457 15.5 1.4908 15.5H10.5091C10.7054 15.5 10.8644 15.331 10.8644 15.1224V5.23684H1.13551V15.1224ZM7.99844 6.81579H9.33076V13.9919H7.99844V6.81579ZM5.33381 6.81579H6.66613V13.9919H5.33381V6.81579ZM2.66918 6.81579H4.0015V13.9919H2.66918V6.81579Z"
              fill="#C5C5C5"
            />
            <path
              d="M8.99468 0.877568C8.99468 0.669037 8.83562 0.5 8.6394 0.5H3.36077C3.16454 0.5 3.00548 0.669037 3.00548 0.877568V2.70709H0.522032C0.325808 2.70709 0.166748 2.87613 0.166748 3.08466V4.03946C0.166748 4.24797 0.325808 4.41702 0.522032 4.41702H11.4781C11.6744 4.41702 11.8334 4.24797 11.8334 4.03946V3.08466C11.8334 2.87613 11.6744 2.70709 11.4781 2.70709H8.99468V0.877568ZM7.66237 2.62947H4.3378V1.91588H7.66237V2.62947Z"
              fill="#C5C5C5"
            />
          </svg>
        </button>

        <div
          v-if="dropDownFile && attachedFiles.length > 1"
          class="attach-dropdown"
          ref="dropdown"
          tabindex="0">
          <div
            v-for="(file, index) in attachedFiles"
            :key="`attach-${index}`"
            class="attach-dropdown-item">
            <div class="attach-dropdown-item-upload">
              <svg
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.85294 10.1562C8.68247 10.1562 8.52806 10.2245 8.41647 10.3346L7.82353 10.9196V7.1045C8.07224 6.91925 8.23529 6.62756 8.23529 6.29688C8.23529 5.73584 7.77453 5.28125 7.20588 5.28125C6.63724 5.28125 6.17647 5.73584 6.17647 6.29688C6.17647 6.62797 6.33953 6.91925 6.58824 7.1045V10.9196L5.99529 10.3346C5.88371 10.2245 5.72929 10.1562 5.55882 10.1562C5.21788 10.1562 4.94118 10.4292 4.94118 10.7656C4.94118 10.9338 5.01035 11.0862 5.12235 11.1962L6.76941 12.8212C6.881 12.9318 7.03541 13 7.20588 13C7.37635 13 7.53076 12.9318 7.64276 12.8217L9.28982 11.1967C9.40141 11.0862 9.47059 10.9338 9.47059 10.7656C9.47059 10.4292 9.19388 10.1562 8.85294 10.1562ZM12.3529 4.67188C12.3529 3.0225 11.0242 1.68309 9.366 1.63028C8.57418 0.638625 7.34959 0 5.97059 0C3.67253 0 1.79859 1.77003 1.66024 4.00319C0.674059 4.51181 0 5.52866 0 6.70312C0 8.38622 1.38229 9.75 3.08824 9.75H3.91176C4.25271 9.75 4.52941 9.477 4.52941 9.14062C4.52941 8.80425 4.25271 8.53125 3.91176 8.53125H3.08824C2.06665 8.53125 1.23529 7.71103 1.23529 6.70312C1.23529 6.02103 1.61741 5.40028 2.23259 5.08341L2.85065 4.7645L2.89347 4.07753C2.99271 2.47447 4.34453 1.21875 5.97059 1.21875C6.92053 1.21875 7.80418 1.64369 8.39588 2.38428L8.75167 2.82994L9.32649 2.84822C10.3308 2.88031 11.1176 3.68144 11.1176 4.67188V5.48397L11.8778 5.79678C12.4163 6.01859 12.7647 6.53372 12.7647 7.10938C12.7647 7.89344 12.1182 8.53125 11.3235 8.53125H10.5C10.1591 8.53125 9.88235 8.80425 9.88235 9.14062C9.88235 9.477 10.1591 9.75 10.5 9.75H11.3235C12.8018 9.75 14 8.56781 14 7.10938C14 6.01087 13.3202 5.07 12.3529 4.67188Z"
                  fill="#1D89BF"
                />
              </svg>
            </div>

            <a
              @click="downloadAttachedFiles(file.DownloadLink, file.AttachName)"
              class="link link-blue link-effect link-effect--border-bottom-blue attach-dropdown-item-text">
              {{ file.AttachName.substring(20, -1) }}
              <span v-if="file.AttachName.length > 20" class="dots">...</span>
            </a>

            <div class="attach-dropdown-item-remove">
              <svg
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="svg-ic-del"
                @click="deleteAttachedFile(file.AttachGUID)"
                v-if="
                  controlView == 'PMInterface' &&
                    jobData.JobTypeData.JobStatusName !== 'Cancelled' &&
                    controlView == 'PMInterface' &&
                    jobData.JobTypeData.JobStatusName !== 'Ready'
                ">
                <path
                  d="M0.996443 14.6224C0.996443 14.831 1.16005 15 1.36188 15H10.6379C10.8397 15 11.0033 14.831 11.0033 14.6224V4.73684H0.996443V14.6224ZM8.05546 6.31579H9.42584V13.4919H8.05546V6.31579ZM5.31469 6.31579H6.68507V13.4919H5.31469V6.31579ZM2.57393 6.31579H3.94431V13.4919H2.57393V6.31579Z"
                  fill="#C5C5C5"
                />
                <path
                  d="M9.08016 0.377568C9.08016 0.169037 8.91655 0 8.71472 0H3.28528C3.08345 0 2.91984 0.169037 2.91984 0.377568V2.20709H0.365435C0.163605 2.20709 0 2.37613 0 2.58466V3.53946C0 3.74797 0.163605 3.91702 0.365435 3.91702H11.6346C11.8364 3.91702 12 3.74797 12 3.53946V2.58466C12 2.37613 11.8364 2.20709 11.6346 2.20709H9.08016V0.377568ZM7.70978 2.12947H4.29022V1.41588H7.70978V2.12947Z"
                  fill="#C5C5C5"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade" tag="div">
      <span>
        <button
          v-if="
            controlView != 'assignJobState' && controlView != 'assignJobStateQA'
          "
          :disabled="
            jobData.JobTypeData.JobStatusName == 'Ready' ||
              jobData.JobTypeData.JobStatusName == 'Cancelled'
          "
          @click="$refs.uploadFile.click()"
          class="btn btn-blue">
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.9176 7.56C10.7582 7.407 10.5376 7.3125 10.2941 7.3125C10.0506 7.3125 9.83 7.407 9.67059 7.56L7.31765 9.81C7.15765 9.96244 7.05882 10.1734 7.05882 10.4062C7.05882 10.872 7.45412 11.25 7.94118 11.25C8.18471 11.25 8.40529 11.1555 8.56471 11.0025L9.41177 10.1931V15.4755C9.05706 15.732 8.82353 16.1359 8.82353 16.5938C8.82353 17.3706 9.48176 18 10.2941 18C11.1065 18 11.7647 17.3706 11.7647 16.5938C11.7647 16.1359 11.5318 15.732 11.1765 15.4755V10.1931L12.0235 11.0025C12.1829 11.1555 12.4035 11.25 12.6471 11.25C13.1347 11.25 13.5294 10.872 13.5294 10.4062C13.5294 10.1734 13.4306 9.96244 13.2712 9.81L10.9176 7.56ZM17.6471 6.46875C17.6471 4.185 15.7488 2.33044 13.38 2.25731C12.2488 0.88425 10.4994 0 8.52941 0C5.24647 0 2.56941 2.45081 2.37176 5.54287C0.962941 6.24712 0 7.65506 0 9.28125C0 11.6117 1.97471 13.5 4.41177 13.5H5.58824C6.07529 13.5 6.47059 13.122 6.47059 12.6562C6.47059 12.1905 6.07529 11.8125 5.58824 11.8125H4.41177C2.95235 11.8125 1.76471 10.6768 1.76471 9.28125C1.76471 8.33681 2.31059 7.47731 3.18941 7.03856L4.07235 6.597L4.13353 5.64581C4.27529 3.42619 6.20647 1.6875 8.52941 1.6875C9.88647 1.6875 11.1488 2.27588 11.9941 3.30131L12.5024 3.91838L13.3236 3.94369C14.7582 3.98812 15.8824 5.09737 15.8824 6.46875V7.59319L16.9683 8.02631C17.7376 8.33344 18.2353 9.04669 18.2353 9.84375C18.2353 10.9294 17.3118 11.8125 16.1765 11.8125H15C14.5129 11.8125 14.1176 12.1905 14.1176 12.6562C14.1176 13.122 14.5129 13.5 15 13.5H16.1765C18.2882 13.5 20 11.8631 20 9.84375C20 8.32275 19.0288 7.02 17.6471 6.46875Z"
              fill="white"
            />
          </svg>
          <span>upload file</span>
        </button>

        <input
          ref="uploadFile"
          @change="uploadAttachments"
          v-validate="{
            rules: { size: 15360, mimes: ['image/*', 'application/pdf'] }
          }"
          data-vv-name="fileAttach"
          data-vv-as="files"
          type="file"
          style="display:none;"
          name="fileAttach"
          accept="application/pdf, image/*"
          />
      </span>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import helpers from '@/mixins/helpers';

export default Vue.extend({
  props: {
    jobData: {
      type: Object,
      required: true,
    },
    controlView: {
      type: String,
      required: true,
    },
  },
  mixins: [
    helpers.general,
  ],
  components: {
    'pre-loader': () => import('@/components/preloader/index.vue'),
  },
  data: () => ({
    load: true,
    attachedFiles: Array(),
    dropDownFile: false,
    loadFile: false,
  }),
  methods: {
    uploadAttachments(event) {
      this.$validator.validate().then((result) => {
        if (!result) {
          return this.$root.$emit('notification', {
            message: this.errors.items.find((item) => item.field === 'fileAttach').msg,
            type: 'error',
            show: true,
          });
        }
        this.dropDownFile = false;

        const formData = new FormData();
        formData.append('attach', this.$refs.uploadFile.files[0]);

        Api.jobs.uploadAttachments(this.jobData.ID, formData).then((data) => {
          if (data.data.Status) {
            this.attachedFiles.push(data.data.Data);

            this.$refs.uploadFile.value = '';

            this.$root.$emit('notification', {
              message: 'File was uploaded',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
      });
    },
    deleteAttachedFile(id) {
      Api.jobs.removeFiles(`${this.$route.params.id}/${id}`).then((response) => {
        if (response.data.Status) {
          this.attachedFiles = this.attachedFiles.filter(
            (file) => file.AttachGUID !== id
          );

          this.$root.$emit('notification', {
            message: 'File was deleted',
            type: 'info',
            show: true,
          });
        }
      });
    },
    downloadAttachedFiles(file, name) {
      this.loadFile = true;
      Api.jobs.getFiles(file.slice(3)).then((response) => {
        if (response.data.Status) {
          this.donwloadFileOnLink(response.data.Data, name);
        } else {
          this.$root.$emit('notification', {
            message: response.data.Message,
            type: 'error',
            show: true,
          });
        }
      }).finally(() => {
        this.loadFile = false;
      });
    },
  },
  mounted() {
    Api.jobs
      .getAttachment(this.$route.params.id)
      .then((response) => {
        if (response.data.Status) {
          this.attachedFiles = response.data.Data;
        }
      })
      .finally(() => {
        this.load = false;
      });
  },
});
</script>

<style lang="scss" scoped>
.dropdown-file-holder {
  position: relative;
  height: 40px;
}
.attachments-wrapper {
  position: relative;

  .btn {
    display: flex;
    align-items: center;

    span {
      margin-left: 5px;
    }

    svg {
      position: static;
      margin: 0;
    }
  }
}
</style>
